module.exports = __webpack_public_path__ + "img/bg-img.4b85d9d8.png";